module.exports = __webpack_public_path__ + "img/bgw4.9868ce87.jpg";